/**
 * Why an order can be put on hold (spec 20261027, decision D2). The values are
 * the ones Prism accepts; the labels are the same words its messages use.
 * The one place the screen names a reason.
 */

export const HOLD_REASONS = [
  { value: 'address_confirmation', label: 'Address confirmation' },
  { value: 'partial_refund_pending', label: 'Partial refund pending' },
  { value: 'cancellation_pending_damaged', label: 'Cancellation pending (damaged)' },
  { value: 'other', label: 'Other' }
]

/** The readable label for a reason value. An unknown value is shown as it came. */
export function holdReasonLabel(reason) {
  return HOLD_REASONS.find((r) => r.value === reason)?.label ?? String(reason ?? '')
}

/** Longest optional note Prism accepts on a hold. */
export const HOLD_NOTE_MAX_LENGTH = 500
